import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'
import type { Lang } from './i18n'
import { toPersianNums } from './persian'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function sectionNum(n: string, lang: Lang): string {
  return lang === 'fa' ? toPersianNums(n) : n
}
